import { css } from 'styled-components';
var screens = {
  miniPhone: 300,
  phone: 500,
  phablet: 640,
  tablet: 800,
  miniDesktop: 1024,
  desktop: 1200,
  bigScreen: 1300,
  hugeScreen: 1500
};
export var minMediaQueries = {
  miniPhone: function miniPhone() {
    return css(["@media (min-width:", "px){", ";}"], screens.miniPhone, css.apply(void 0, arguments));
  },
  phone: function phone() {
    return css(["@media (min-width:", "px){", ";}"], screens.phone, css.apply(void 0, arguments));
  },
  phablet: function phablet() {
    return css(["@media (min-width:", "px){", ";}"], screens.phablet, css.apply(void 0, arguments));
  },
  tablet: function tablet() {
    return css(["@media (min-width:", "px){", ";}"], screens.tablet, css.apply(void 0, arguments));
  },
  miniDesktop: function miniDesktop() {
    return css(["@media (min-width:", "px){", ";}"], screens.miniDesktop, css.apply(void 0, arguments));
  },
  desktop: function desktop() {
    return css(["@media (min-width:", "px){", ";}"], screens.desktop, css.apply(void 0, arguments));
  },
  bigScreen: function bigScreen() {
    return css(["@media (min-width:", "px){", ";}"], screens.bigScreen, css.apply(void 0, arguments));
  },
  hugeScreen: function hugeScreen() {
    return css(["@media (min-width:", "px){", ";}"], screens.hugeScreen, css.apply(void 0, arguments));
  }
};
export var maxMediaQueries = {
  miniPhone: function miniPhone() {
    return css(["@media (max-width:", "px){", ";}"], screens.miniPhone - 1, css.apply(void 0, arguments));
  },
  phone: function phone() {
    return css(["@media (max-width:", "px){", ";}"], screens.phone - 1, css.apply(void 0, arguments));
  },
  phablet: function phablet() {
    return css(["@media (max-width:", "px){", ";}"], screens.phablet - 1, css.apply(void 0, arguments));
  },
  tablet: function tablet() {
    return css(["@media (max-width:", "px){", ";}"], screens.tablet - 1, css.apply(void 0, arguments));
  },
  miniDesktop: function miniDesktop() {
    return css(["@media (max-width:", "px){", ";}"], screens.miniDesktop - 1, css.apply(void 0, arguments));
  },
  desktop: function desktop() {
    return css(["@media (max-width:", "px){", ";}"], screens.desktop - 1, css.apply(void 0, arguments));
  },
  bigScreen: function bigScreen() {
    return css(["@media (max-width:", "px){", ";}"], screens.bigScreen - 1, css.apply(void 0, arguments));
  },
  hugeScreen: function hugeScreen() {
    return css(["@media (max-width:", "px){", ";}"], screens.hugeScreen - 1, css.apply(void 0, arguments));
  }
};
export var hoverMediaQuery = function hoverMediaQuery() {
  return css(["@media (hover:hover),screen and (-ms-high-contrast:active),screen and (-ms-high-contrast:none){", ";}"], css.apply(void 0, arguments));
};
export var ieMediaQuery = function ieMediaQuery() {
  return css(["@media screen and (-ms-high-contrast:active),screen and (-ms-high-contrast:none){", ";}"], css.apply(void 0, arguments));
};